module.exports = __webpack_public_path__ + "img/icon-3.04f3f3e5.png";